import HomeInfo from './HomeInfo';

export default HomeInfo;
